<template>
  <div
    class="oct-account-header"
    :class="{
      'oct-account-header--sticking': sticking
    }"
    v-if="user"
  >
    <div class="oct-account-header__content">
      <div class="oct-account-header__primary-action">
        <a :href="href" class="oct-account-header__icon">
          <oct-icon icon="arrow-back" />
        </a>
      </div>
      <div class="oct-account-header__user">
        <figure class="oct-account-header__profile-icon">
          <picture class="oct-account-header__picture">
            <img
              class="oct-account-header__image"
              :src="user.profileIcon.lowResolution"
              :alt="getLocaleString(user, 'tradeName') || user.displayName || ''"
              v-if="user.profileIcon && user.profileIcon.lowResolution"
            />
            <oct-icon
              class="oct-account-header__image"
              icon="account-circle"
              v-else
            />
          </picture>
        </figure>

        <div class="oct-account-header__text">
          <h1 class="oct-account-header__primay-text">{{ getLocaleString(user, 'tradeName') || user.displayName || '' }}</h1>
          <p class="oct-account-header__secondary-text">{{ Array.isArray(user.position) ? user.position.join(',') : '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OctComponent from '@/components/base/component'
import OctIcon from '@/components/icon/OctIcon.vue';

export default {
  name: 'OctAccountHeader',
  mixins: [ OctComponent ],
  components: {
    OctIcon
  },
  props: {
    /** User to dispaly */
    user: {
      type: Object,
      default: () => {}
    },
    /** Href to return */
    href: {
      type: String,
      default: '/account/dashboard'
    },
  },
  data () {
    return {
      /** Sticking state */
      sticking: false
    }
  },
  methods: {
    onScroll () {
      // Boundeing rect
      const rect = this.$el.getBoundingClientRect()

      // Update sticking status
      this.sticking = rect.top === 0
    }
  },
  mounted () {
    // Listen to scroll event
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    // Stop listening to scroll event
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-account-header {
  position: sticky;
  top: 0;
  padding: 0 oct-rem(20);
  background-color: $oct-theme--surface;
  z-index: 3;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  padding: 0 oct-rem(40);
}
}

.oct-account-header__content {
  display: flex;
  align-items: center;
  padding: oct-rem(12-1) 0;
  border-top: 1px solid $oct-theme--primary;
  border-bottom: 1px solid $oct-theme--primary;
  transition-duration: .2s;

  .oct-account-header--sticking & {
    border-top-color: transparent;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  padding: oct-rem(16-1) 0;
}
}

.oct-account-header__primary-action {
  margin: 0 oct-rem(20) 0 0;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(70) 0 0;
}
}

.oct-account-header__icon {
  position: relative;
  display: block;
  width: oct-rem(26);
  height: oct-rem(40);

  .oct-icon {
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    width: oct-rem(43);
    height: oct-rem(43);
    margin: auto;
    transition-duration: .2s;
    transition-timing-function: ease-out;
  }

  &:hover {
    .oct-icon {
      transform: translateX(-15%);
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(32);
  height: oct-rem(48);

  .oct-icon {
    width: oct-rem(48);
    height: oct-rem(48);
  }
}
}

.oct-account-header__user {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.oct-account-header__profile-icon {
  margin: 0 oct-rem(12) 0 0;
  flex: 0 0 oct-rem(48);
  width: oct-rem(48);
  height: oct-rem(48);
  border-radius: 50%;
  overflow: hidden;
}

.oct-account-header__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.oct-account-header__text {
  flex: 1 1 auto;
  padding: oct-rem(4) 0;
  overflow: hidden;
}

.oct-account-header__primay-text {
  font-size: oct-rem(15);
  font-weight: normal;
  line-height: (20/15);
  letter-spacing: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: (-4em/15) 0 ((-4em+8)/15);

  &:last-child {
    margin-bottom: (-4em/15);
  }
}

.oct-account-header__secondary-text {
  font-size: oct-rem(13);
  font-weight: normal;
  line-height: (18/13);
  letter-spacing: 0;
  margin: (-4em/13) 0;
  opacity: .55;
}
</style>
